import type { PointerEvent } from 'react'

export function setCardPointer(event: PointerEvent<HTMLElement>) {
  const card = event.currentTarget
  const rect = card.getBoundingClientRect()
  const x = ((event.clientX - rect.left) / rect.width) * 100
  const y = ((event.clientY - rect.top) / rect.height) * 100
  const rotateX = ((event.clientY - rect.top) / rect.height - 0.5) * -3
  const rotateY = ((event.clientX - rect.left) / rect.width - 0.5) * 3
  card.style.setProperty('--pointer-x', `${x}%`)
  card.style.setProperty('--pointer-y', `${y}%`)
  card.style.setProperty('--rotate-x', `${rotateX}deg`)
  card.style.setProperty('--rotate-y', `${rotateY}deg`)
}

export function resetCardPointer(event: PointerEvent<HTMLElement>) {
  const card = event.currentTarget
  card.style.setProperty('--rotate-x', '0deg')
  card.style.setProperty('--rotate-y', '0deg')
}
